(function () {
  SUGApp.controller("completeRegistrationController", ["$scope", "$window", "$timeout", "loginfactory",
    function ($scope, $window, $timeout, loginfactory) {
      // create an instance of the login service
      $scope.login = loginfactory.getLogin(false);

      $window.showRegistrationVariation = function(type) {
        if (type === "A") {
          $scope.showDefault = false;
          $scope.showVariantA = true;
        }
        if (type === "default") {
          $scope.showDefault = true;
          $scope.showVariantA = false;
        }
        $scope.$apply();
      }

      /* If Google Optimize doesn't load or is slow, after 1 second show default */
      $timeout(function() {
        if(!$scope.showVariantA){
          $window.showRegistrationVariation("default");
        }
        }, 1000);
  },
]);
})();
